import { Tabs as TabsAnt } from 'antd';
import styled from 'styled-components';

export const Tabs = styled(TabsAnt)`
	.ant-tabs-content {
		margin-top: 2rem;
	}
`;
